/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import StatusTracking from '../../../common/StatusTracking';
import configEnv from '../../../config';

const {
    FEDEX_ORDERTRACKING_URL,
    UPS_ORDERTRACKING_URL,
    USPS_ORDERTRACKING_URL,
} = configEnv;

class OrderTracking extends React.Component {
    openTrakingWindow = (trackingUrl) => {
        if (typeof window !== 'undefined') window.open(trackingUrl);
    };

    render() {
        const {
            // eslint-disable-next-line object-curly-newline
            data: { status, trackingNumber, carrier, isPassport },
        } = this.props;

        // I -> In transit
        // D/U -> Delivered
        // C -> Cancelled
        // W and all other status -> Order Received

        // console.log(status, carrier);

        let trackingUrl;
        const statusBar = isPassport ? 'D' : status;

        if (carrier) {
            if (carrier === 'FEDEX') {
                trackingUrl = FEDEX_ORDERTRACKING_URL + trackingNumber;
            } else if (carrier === 'UPS') {
                trackingUrl = UPS_ORDERTRACKING_URL + trackingNumber;
            } else if (carrier === 'USPS') {
                trackingUrl = USPS_ORDERTRACKING_URL + trackingNumber;
            }
        } else if (trackingNumber) {
            if (/^1Z/.test(trackingNumber)) {
                trackingUrl = UPS_ORDERTRACKING_URL + trackingNumber;
            } else if (/^92/.test(trackingNumber)) {
                trackingUrl = USPS_ORDERTRACKING_URL + trackingNumber;
            } else {
                trackingUrl = FEDEX_ORDERTRACKING_URL + trackingNumber;
            }
        }

        return (
            <>
                <StatusTracking status={statusBar} />
                {['W', 'I'].indexOf(statusBar) > -1 ? (
                    <div className="margin-top align-center">
                        <span className="uppercase bold gray-color">
                            Tracking:{' '}
                        </span>
                        {trackingNumber ? (
                            <span>
                                {trackingUrl ? (
                                    <a
                                        className="link"
                                        onClick={() => this.openTrakingWindow(trackingUrl)}
                                    >
                                        {trackingNumber}
                                    </a>
                                ) : (
                                    { trackingNumber }
                                )}
                            </span>
                        ) : (
                            <span>Available on day of shipment</span>
                        )}
                    </div>
                ) : (
                    ''
                )}
                {['C', 'D', 'I', 'U'].indexOf(statusBar) > -1 ? (
                    <div className="margin-top error-color align-center bold">
                        This Order May No Longer Be Modified
                    </div>
                ) : (
                    ''
                )}
            </>
        );
    }
}

OrderTracking.propTypes = {
    data: PropTypes.object.isRequired,
};

export default OrderTracking;
